import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const calculationTypeSelection = {
    name: "Calculation Type",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose calculation type",
    defaultConfig: {
        defaultValue: null,
        key: "Calculation Type",
    },
    type: "input",
    category: "dashboard",
};
